// @ts-nocheck
export const getRightFromTypeId = (typeId) => {
	switch (typeId) {
		case 1:
			return "AdminNews";
		case 3:
			return "AdminArticle";
		case 4:
			return "AdminAds";
		case 13:
			return "AdminAlert";
		case 14:
			return "AdminProAds";
		case 5:
			return "AdminCareer";
		case 8:
			return "AdminEvent";
		//Fake id to have the same behavior as the others
		case "chartTypeId":
			return "AdminChart";
		case "documentTypeId":
			return "AdminDocument";
		case "formTypeId":
			return "AdminForms";
		case "rssTypeId":
			return "AdminRss";
		case "contactTypeId":
			return "AdminEmploye";
		default:
			return "";
	}
};

export const getWriteRightFromTypeId = (typeId) => {
	switch (typeId) {
		case 1:
			return "WriteNews";
		case 3:
			return "WriteArticle";
		case 4:
			return "WriteAds";
		case 13:
			return "WriteAlert";
		case 14:
			return "WriteProAds";
		case 5:
			return "WriteCareer";
		case 8:
			return "WriteEvent";
		//Fake id to have the same behavior as the others
		case "chartTypeId":
			return "WriteChart";
		case "documentTypeId":
			return "WriteDocument";
		case "formTypeId":
			return "WriteForm";
		case "rssTypeId":
			return "WriteRss";
		case "contactTypeId":
			return "WriteEmploye";
		case "siteTypeId":
			return "WriteSites";
		case "categoriesId":
			return "WriteCategories";
		case "groupId":
			return "WriteGroups";
		default:
			return "";
	}
};

export const getMenuRightTemplateKeyFromTypeId = (typeId) => {
	switch (typeId) {
		case 4:
			return "PeoplePage.ViewAd";
		case 14:
			return "PeoplePage.ViewProAd";
		case 3:
			return "CorporatePage.Articles";
		case 5:
			return "PeoplePage.Career";
		case 8:
			return "PeoplePage.Agenda";
		case "chartTypeId":
			return "CorporatePage.Charts";
		case "documentTypeId":
			return "CorporatePage.DocsUtils";
		case "formTypeId":
			return "Forms";
		case "rssTypeId":
			return "PeoplePage.Rss";
		case "contactTypeId":
			return "ContactPage";
		case "siteTypeId":
			return "SitesPage";
		default:
			return "";
	}
};
